// extracted by mini-css-extract-plugin
export var header = "styles-module__header___W_aI9";